import { produce } from "immer";
import * as uiActions from "store/actions/uiActions";

const initialState = {
  messages: {
    byId: {},
    lastId: null
  },
  quarantines: {
    byId: {},
    lastId: null
  },
  archives: {
    byId: {},
    lastId: null
  }
};

const reducer = produce((draft, action) => {
  switch (action.type) {
    case uiActions.SELECT_ALL: {
      const payload = action.payload;
      const byId = payload.list.reduce((obj, id) => {
        obj[id] = true;
        return obj;
      }, {});

      if (payload.isSelected) {
        draft[payload.stateKey].byId = byId;
      } else {
        draft[payload.stateKey].byId = {};
      }

      draft[payload.stateKey].lastId = null;
      break;
    }

    case uiActions.SELECT_RANGE: {
      const payload = action.payload;

      const byId = payload.list.reduce((obj, id) => {
        obj[id] = action.payload.isSelected;
        return obj;
      }, {});

      const oldIds = draft[payload.stateKey].byId;

      draft[payload.stateKey].byId = {
        ...oldIds,
        ...byId
      };

      draft[payload.stateKey].lastId = payload.selectedId;

      break;
    }

    case uiActions.SELECT_SINGLE: {
      const payload = action.payload;

      draft[payload.stateKey].lastId = payload.id;
      if (payload.isSelected) {
        draft[payload.stateKey].byId[payload.id] = true;
      } else {
        draft[payload.stateKey].byId[payload.id] = false;
      }

      break;
    }

    default: {
      return draft;
    }
  }
}, initialState);

export default reducer;
